var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFill4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79688 0C14.7676 0 18.7969 4.0293 18.7969 9C18.7969 13.9707 14.7676 18 9.79688 18C4.82618 18 0.796875 13.9707 0.796875 9C0.796875 4.0293 4.82618 0 9.79688 0ZM9.79688 16.47C13.9162 16.47 17.2669 13.1184 17.2669 9C17.2669 4.8816 13.9162 1.53 9.79688 1.53C5.67757 1.53 2.32687 4.8816 2.32687 9C2.32687 13.1184 5.67757 16.47 9.79688 16.47ZM9.38287 14.7438V13.6395C8.10757 13.5405 7.16257 13.0626 6.52447 12.3633L7.32187 11.2581C7.86538 11.8451 8.592 12.2303 9.38287 12.3507V9.981C8.11927 9.6624 6.78188 9.207 6.78188 7.6005C6.78188 6.3486 7.80067 5.3667 9.38287 5.2317V4.0914H10.3657V5.2434C11.3593 5.355 12.1945 5.7357 12.8317 6.3495L12.0109 7.416C11.5566 6.9779 10.9857 6.67984 10.3666 6.5574V8.6679C11.6428 9.0117 13.0171 9.4905 13.0171 11.1339C13.0171 12.3867 12.2071 13.4784 10.3666 13.6386V14.7429L9.38287 14.7438ZM11.5564 11.2698C11.5564 10.7181 11.0407 10.4481 10.3657 10.2393V12.3633C11.2117 12.2283 11.5564 11.736 11.5564 11.2698ZM8.25337 7.5033C8.25337 7.9803 8.73308 8.2269 9.38377 8.4114V6.4962C8.68447 6.57 8.25427 6.9633 8.25427 7.5033H8.25337Z",
    fill: "#283476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFill4);
export default __webpack_public_path__ + "static/media/Fill-4.1802ab0599a2a7ac7e3a7055edc578b6.svg";
export { ForwardRef as ReactComponent };